import { render, staticRenderFns } from "./AdminSystems.vue?vue&type=template&id=7cd89364&"
import script from "./AdminSystems.vue?vue&type=script&lang=ts&"
export * from "./AdminSystems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports